























































































































































































import Vue from 'vue';

import med_teams from '@/assets/medTeam.json';
import physicians from '@/assets/physicians.json';
import performance from '@/assets/performance.json';
import services from '@/assets/services.json';
import locations from '@/assets/locations.json';
import { DataTypes, DirectoryVue } from '@/dto';

export default Vue.extend({
    name: 'DirectoryPage',
    components: {},
    data(): DirectoryVue {
        return {
            IsTito: false,
            MedTeams: med_teams,
            Physicians: physicians,
            Performance: performance,
            Services: services,
            Locations: locations,
            DataTypes: DataTypes,
            CurrentType: DataTypes.MED,
        };
    },
    mounted() {
        const params = new URLSearchParams(window.location.search);
        if (params.get('u') === 'tito') {
            this.IsTito = true;
        }
    },
    methods: {
        FormatTitle(val: string) {
            return !val ? '' : val.replace(/\*/g, '<br />');
        },
        OnChangeType(type: string) {
            const btn = document.querySelector('button.navbar-toggler') as HTMLButtonElement;
            this.CurrentType = type;
            this.$nextTick(() => {
                btn.click();
                window.scrollTo({
                    top: 0,
                });
            });
        },
    },
});
